import { Component, ReactNode } from 'react';
import { useNavigate, useParams } from 'react-router';
import { AdminApi } from '../admin-api';
import LoadingButton from './LoadingButton';

export default function SiteCarousel(props: any): ReactNode {
  return (
    <SiteCarouselComp
      navigate={useNavigate()}
      params={useParams()}
      {...props}
    />
  );
}

class SiteCarouselComp extends Component {
  constructor(
    readonly props: Readonly<{
      children?: ReactNode;
      navigate?: any;
      currentUser?: any;
      params?: any;
    }>,
  ) {
    super(props);
    this.state = {
      isLoading: false,
      data: [],
      currentImg: null,
    };
  }

  state: Readonly<{
    isLoading: boolean;
    data: any[];
    currentImg: any;
  }>;

  interval: any;
  getMoreInterval: any;

  componentWillUnmount(): void {
    clearInterval(this.interval);
    clearInterval(this.getMoreInterval);
  }

  getNextImage() {
    const _currIndex = this.state.data.findIndex(
      (x) => x.id === this.state.currentImg.id,
    );

    if (_currIndex === this.state.data.length - 1 || _currIndex === -1) {
      this.setState({ currentImg: this.state.data[0] });
    } else {
      this.setState({ currentImg: this.state.data[_currIndex + 1] });
    }
  }

  async getMoreImg() {
    const _data = await AdminApi.get('/site-carousel');

    if (!_data.length) return;

    const _ids = this.state.data.map((a) => a.id);
    const _new = _data.filter((a: any) => !_ids.includes(a.id));

    if (!_new.length) return;

    const _currIndex = this.state.data.findIndex(
      (x) => x.id === this.state.currentImg.id,
    );

    const _dataToUpdate = [...this.state.data];
    _dataToUpdate.splice(_currIndex + 1, 0, ..._new),
      this.setState({
        data: _dataToUpdate,
      });
  }

  async componentDidMount(): Promise<void> {
    this.setState({ isLoading: true });

    const _data = await AdminApi.get('/site-carousel');

    this.setState({
      isLoading: false,
      data: _data,
      currentImg: _data[0],
    });

    this.interval = setInterval(() => {
      this.getNextImage();
    }, 5000);

    this.getMoreInterval = setInterval(async () => {
      await this.getMoreImg();
    }, 10000);
  }

  render(): ReactNode {
    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <main className="col-md-12 ms-sm-auto col-lg-12 px-md-4">
              <div className="mb-3" style={{ width: '100vh' }}>
                {this.state.currentImg ? (
                  <img
                    src={this.state.currentImg.photoUrl}
                    className="d-block w-100"
                  />
                ) : (
                  <LoadingButton />
                )}
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}
